import React, { useContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { decodeToken, decodeTokenWithParam } from "../../../../shared/helpers";

import { demoContext } from "../../../../shared/store/contexts";

import { DashboardLayout } from "../../../organisms/Layouts";
import OrganizationDetailsPage from "../OrganizationDetails";
import CaseManagement from "../CaseManagement";
import EligibilityPage from "../Eligibility";
import ImpactManagementPage from "../ImpactManagement";
import ProgramsPage from "../Programs";
import ReferralsPage from "../Referrals";
import SettingsPage from "../Settings";
import ReferralForms from "../ReferralForms";
import EditReferralFormPage from "../ReferralForms/form.edit";
import AllWidgetsPage from "../Widgets";
import SearchWidgetPage from "../Widgets/Search";
import InitiativePage from "../Initiatives";

const OrganizationDashboardHome = () => {
  const { token } = useContext(demoContext);
  const [, setIsValid] = useState(true);

  useEffect(() => {
    if (token && token) {
      setIsValid(decodeTokenWithParam(token));
    } else {
      setIsValid(decodeToken());
    }
  }, [token]);

  return (
    <Routes>
      <Route element={<DashboardLayout />}>
        <Route path="settings/*" element={<SettingsPage />} />
        <Route path="case-management/*" element={<CaseManagement />} />
        <Route path="organization-details" element={<OrganizationDetailsPage />} />
        <Route path="eligibility/*" element={<EligibilityPage />} />
        <Route path="referrals" element={<ReferralsPage />} />
        <Route path="initiatives/*" element={<InitiativePage />} />
        <Route path="programs/*" element={<ProgramsPage />} />
        <Route path="widgets/search" element={<SearchWidgetPage />} />
        <Route path="widgets" element={<AllWidgetsPage />} />

        <Route path="/impact-management" element={<ImpactManagementPage />} />
        <Route path="" element={<ImpactManagementPage />} />

        <Route path="referral-forms/*" element={<ReferralForms />} />

        <Route
          path="referral-forms/edit/:formId"
          element={<EditReferralFormPage />}
        />
      </Route>
    </Routes>
  );
};

export default OrganizationDashboardHome;
